module.exports = __webpack_public_path__ + "img/CHEVRON_TOP.060f7c53.svg";